import {detect} from 'detect-browser';

export class FormValidator {
  private forms;
  private submitInputs;
  private submitButtons;

  constructor() {
    if (document.querySelectorAll('.js-form').length) {
      this.init();
    }
  }

  init() {
    this.forms = document.getElementsByClassName('js-form');
    this.submitInputs = document.querySelectorAll('input[type=submit]');
    // for ext:forms
    this.submitButtons = document.querySelectorAll('button[type=submit]');
    if (this.submitButtons !== null) {
      for (let submitButton of this.submitButtons) {
        submitButton.addEventListener('click', (): void => {
          const currentForm = submitButton.closest('.js-form');
          if (currentForm) {
            this.validateFormsExtChoices(currentForm);
          }
        });
      }
    }
    if (this.submitInputs !== null) {
      for (let submitButton of this.submitInputs) {
        submitButton.addEventListener('click', (): void => {
          const currentForm = submitButton.closest('.js-form');
          if (currentForm) {
            this.validateChoices(currentForm);
            this.validateZip(currentForm);
            const invalidInputs = currentForm.querySelectorAll('input:invalid');
            invalidInputs.forEach((invalidInput): void => {
              if (invalidInput.type === 'email' && invalidInput.value.length > 0) {
                invalidInput.parentElement.querySelector('.js-error-empty-filed').classList.add('hidden');
                invalidInput.parentElement.querySelector('.js-error-invalid-email').classList.remove('hidden');
              } else {
                invalidInput.parentElement.querySelector('.js-error-empty-filed').classList.remove('hidden');
              }
              if (invalidInput.id === 'zip' && invalidInput.value.length > 0) {
                invalidInput.parentElement.querySelector('.js-error-empty-filed').classList.add('hidden');
              }
            });
            const validInputs = submitButton.closest('.js-form').querySelectorAll('input:valid');
            validInputs.forEach((validInput): void => {
              const errorDiv = validInput.parentElement.querySelectorAll('.js-error-message');
              if (errorDiv) {
                errorDiv.forEach(input => {
                  input.classList.add('hidden');
                });
              }
            });
          }
        });
      }
    }
  }

  private validateChoices(currentForm) {
    const requiredChoices = currentForm.querySelector('.js-choices');
    if (requiredChoices) {
      const option = requiredChoices.options[0].value;
      const errorMsg = currentForm.querySelector('.js-error-empty-fieldChoices');
      const invalidInput = currentForm.querySelector('.js-choices__outer');
      const browser = detect();
      if (option.length > 0) {
        if (errorMsg) {
          requiredChoices.setCustomValidity('');
          invalidInput.classList.remove('invalid-choices');
          errorMsg.classList.add('hidden');
        }
      } else {
        if (errorMsg) {
          if (browser && browser.name === 'firefox') {
            invalidInput.classList.add('invalid-choices');
          }
          requiredChoices.setCustomValidity('Invalid field');
          errorMsg.classList.remove('hidden');
        }
      }
    }
  }

  private validateZip(currentForm) {
    const zipInput = currentForm.querySelector('.js-zip');
    if (zipInput) {
      const errorMsg = currentForm.querySelector('.js-error-invalid-zip');
      const pattern = /[~`!@#$%^&()_={}[\]:;,.<>+\/?*]/;
      if (errorMsg) {
        if (!pattern.test(zipInput.value) && zipInput.value.length < 11) {
          errorMsg.classList.add('hidden');
          zipInput.setCustomValidity('');
        } else {
          zipInput.setCustomValidity('Invalid field');
          errorMsg.classList.remove('hidden');
        }
      }
    }
  }

  private validateFormsExtChoices(currentForm) {
    const requiredChoices = currentForm.querySelectorAll('.js-choices');
    requiredChoices.forEach(elem => {
      const option = elem.options[0].value;
      if (option.length > 0) {
        if (elem.classList.contains('required')) {
          elem.parentElement.classList.remove('choices__inner--required');
        }
      } else {
        if (elem.classList.contains('required')) {
          elem.parentElement.classList.add('choices__inner--required');
        }
      }
    });
  }
}
